import React from 'react';
import Modal from '~/app/common/Modal';
import classes from './style.module.scss';
import Header from './Header';
import Form from './Form';
import {IssueDetails, IssuePayload, Machine} from "~/types";

export interface AddIssueProps {
    onClose: () => void
    open: boolean
    type: IssuePayload['issueType']
    inspectionType?: IssuePayload['inspectionType']
    issueDetails?: IssueDetails
    onSave?: (id: IssueDetails['id']) => void
    sourceTypeId?: IssuePayload['sourceTypeId']
    machineId?: Machine['id'],
    allowAddMore?: boolean
    isWorkOrderChecklist?: boolean
}

export type AddIssueComponent = React.FC<AddIssueProps>
const AddIssue: AddIssueComponent = ({onClose, open, type, inspectionType, issueDetails, onSave, sourceTypeId, machineId, allowAddMore, isWorkOrderChecklist = false}) => {
    return (
        <Modal open={open} position={'top-center'} className={classes['add-issue']}>
            <Header type={type} issueId={issueDetails?.id} issueDetails={issueDetails} />
            <Form onClose={onClose} type={type} inspectionType={inspectionType} issueDetails={issueDetails} onSave={onSave} sourceTypeId={sourceTypeId} machineId={machineId} allowAddMore={allowAddMore} isWorkOrderChecklist={isWorkOrderChecklist} />
        </Modal>
    );
};

export default AddIssue
